import React from "react";
import { Breadcrumb } from "antd";
import { Link, useLocation } from "react-router-dom";

const Breadcrumbs = () => {
  const location = useLocation();
  const pathnames = location.pathname.split("/").filter((x) => { return x !== ''; });

  // Check if the current page is the home page
  const isHomePage = location.pathname === "/";

  // Define an array of paths where breadcrumbs should NOT be displayed
  const excludedPaths = [
    "/login", "/register", "/admin/brands", "/admin/dashboard", "/admin/orders",
    "/admin/showroom",  "/admin/categories","/admin/products", "/admin/banner", "/admin/users", 
    "/admin/customers", "/admin/login", "/admin/register", "/sign-in", "/sign-up",
    "/content/dashboard", "/content/products", "/content/showroom", "/content/brands",
    "/content/categories", "/content/banner", "/fulfillment/dashboard", "/fulfillment/orders",
    "/cart", "/order-status", "/order-history", "/order-received","/agent-dashboard/orders","/agent-dashboard","/flashSale"
  ]; 

  // Define regex patterns for dynamic paths
  const dynamicPathPatterns = [
    /^\/cart\/.+$/, /^\/cart\/update\/.+$/, /^\/order-success\/.+$/,
    /^\/payment-status-checker\/.+$/, /^\/product\/.+$/, /^\/category\/.+$/,
    /^\/brand\/.+$/, /^\/showroom\/.+$/
  ];

  // Check if the path should be excluded
  const isExcluded = isHomePage || excludedPaths.some((path) => location.pathname.startsWith(path)) ||
                     dynamicPathPatterns.some((pattern) => pattern.test(location.pathname));

  if (isExcluded) {
    return null; // Do not render breadcrumbs
  }

  return (
    <div className="container mx-auto px-6 mt-2">
      <Breadcrumb separator=" > ">
        <Breadcrumb.Item>
          <Link to="/">Home</Link>
        </Breadcrumb.Item>
        {pathnames.map((value, index) => {
          const url = `/${pathnames.slice(0, index + 1).join("/")}`;
          return (
            <Breadcrumb.Item key={url}>
              <Link to={url}>{value.replace(/-/g, " ")}</Link>
            </Breadcrumb.Item>
          );
        })}
      </Breadcrumb>
    </div>
  );
};

export default Breadcrumbs;
